import Axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Contact = () => {
  const { i18n } = useTranslation();
  const [flyTo, setFlyTo] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  //수신자 체크
  const handleFlyTo = (e) => {
    setFlyTo(e.target.value);
  };
  //이름 체크
  const handleName = (e) => {
    setName(e.target.value);
  };
  //이메일주소 체크
  const handleEmail = (e) => {
    setEmail(e.target.value);
  };
  //내용 체크
  const handleMessage = (e) => {
    setMessage(e.target.value);
  };
  //문의접수
  const handleInsert = () => {
    Axios.post("http://micronpharm.com/api/post/contact", {
      flyTo,
      name,
      email,
      message,
    })
      .then((res) => {
        console.log(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleSubmit = () => {
    //FORM 입력값 확인
    if (flyTo === "") {
      alert("수신자 이메일을 선택해주세요..");
      document.getElementById("flyto").focus();
      return;
    } else if (name === "") {
      alert("이름을 입력해주세요.");
      document.getElementById("name").focus();
      return;
    } else if (email === "") {
      alert("이메일을 입력해주세요.");
      document.getElementById("email").focus();
      return;
    } else if (message === "") {
      alert("문의내용을 입력해주세요.");
      document.getElementById("message").focus();
      return;
    }

    //insert 실행
    handleInsert();
    alert(` ${name}님 문의접수가 정상적으로 완료되었습니다!`);
    setFlyTo("");
    setName("");
    setEmail("");
    setMessage("");
  };

  return (
    <div className="sub-wrap">
      <div className="main-box">
        <div className="inner_page_title">Contact Us</div>
        <div className="inner_page_title sub">sklover777@dankook.ac.kr</div>
        <div className="inner_page_title sub">cindy9510@naver.com</div>

        <div className="input-box">
          <select
            value={flyTo}
            onChange={handleFlyTo}
            id="flyto"
            style={{ border: "1px solid #c6c6c6", padding: 10, width: "100%" }}
          >
            <option value="">
              {i18n.language === "ko"
                ? "-- 전송받을 이메일을 선택해주세요 --"
                : "-- Please select the email to be sent --"}
            </option>
            <option value="sklover777@dankook.ac.kr">
              sklover777@dankook.ac.kr
            </option>
            <option value="cindy9510@naver.com">cindy9510@naver.com</option>
          </select>
          <input
            type="text"
            value={name}
            onChange={handleName}
            id="name"
            placeholder="NAME"
          />
          <input
            type="email"
            value={email}
            onChange={handleEmail}
            id="email"
            placeholder="EMAIL"
          />
          <textarea
            type="text"
            value={message}
            onChange={handleMessage}
            id="message"
            placeholder="MESSAGE"
            style={{ fontFamily: "Arial, sans-serif" }}
          />
          <div className="contact_btn_box">
            <div className="contact_btn" onClick={handleSubmit}>
              SEND MESSAGE {">"}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
